import { render, staticRenderFns } from "./FichaHistoria.vue?vue&type=template&id=6fb9c578&"
import script from "./FichaHistoria.vue?vue&type=script&lang=js&"
export * from "./FichaHistoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports